import React from "react";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import AdviserSiteTagManager from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { UserStore } from "../../../../../Stroes/Variable";
import { Urls } from "../../../../../Urls";
import { portfolioDashboardTabEnum } from "../../Resource/Content";
import { IPortfolioDashboardComponentProps, PortfolioDashboardComponent } from "../Common/PortfolioDashboardComponent";
import { ConsolidatedAccountStore, PortfolioDashboardStore } from "../../Store/Variable";
import { isConsolidate, orderHeadAccountGroupByInvestorType } from "../Common/PortfolioDashboardHelper";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { ImpactRedirectAction } from "../../../../../../Shared/Impact/Action/ImpactRedirectAction";
import { ImpactRedirectType } from "../../../../../../../Wrap/Models/Domains/Impact/ImpactRedirectType";
import { EsgAccountSelector } from "./EsgAccountSelector";


interface IPortfolioDashboardEsgAnalyserState {
    selectedHeadAccount: ClientAccount;
    isPopUp: boolean;
}

interface IPortfolioDashboardEsgAnalyserProps extends IPortfolioDashboardComponentProps {
}


export class EsgAnalyser extends PortfolioDashboardComponent<IPortfolioDashboardEsgAnalyserProps, IPortfolioDashboardEsgAnalyserState> {
    initState() {
    }

    getData(): ClientAccount[] {
        let accounts = orderHeadAccountGroupByInvestorType(PortfolioDashboardStore.getData());

        if (isConsolidate()) {
            accounts = [ConsolidatedAccountStore.getData()].concat(accounts);
        }

        return accounts;
    }
    constructor(props: IPortfolioDashboardEsgAnalyserProps) {
        super(props);
        
        this.state = {
            selectedHeadAccount: null,
            isPopUp: false
        }
    }

    componentDidMount(): void {
        var accounts = this.getData();

        let indexIsBtnPresentationClicked = Object.keys(portfolioDashboardTabEnum).indexOf(
            portfolioDashboardTabEnum.ESG
        );

        if (this.props.isBtnPresentationClicked[indexIsBtnPresentationClicked]) {
            this.props.onPresentationViewStatusChange(
                portfolioDashboardTabEnum.ESG,
                this.props.isBtnPresentationClicked
            );
        } else {
            this.addEvent({
                environment: {
                    appType: "web",
                    setting: "prod",
                    timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
                },
                page: {
                    pageUrl: Urls.get()
                        .main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                HierarchyLevelName.Customer,
                                this.props.customerid
                            ),
                        })
                        .esg.getUrl(),
                    pageTitle: `${document.title} - ESG Hub`,
                },
                user: {
                    loginId: UserStore.getUserInfo()?.ClientId.toString(),
                    internal: "yes",
                },
                event: "pageLoaded",
            });
        }

        if (!!accounts[0]?.HierarchyId) {
            this.setState({
                selectedHeadAccount: accounts[0]
            });
        }
    }

    private renderAccountSelector() {
        if (this.state.isPopUp) {
            return (
                <>
                    <EsgAccountSelector
                        isPopUp={this.state.isPopUp}
                        accounts={this.getData()}
                        onClose={() => {
                            this.setState({ ...this.state, isPopUp: false });
                        }}
                    />
                </>
            );
        }
    }

    private onEsgLinkClick(accounts: ClientAccount[]) {
        if (accounts.length === 1) {
            ImpactRedirectAction.redirectToImpact(this.state.selectedHeadAccount?.HeadClAccountId, ImpactRedirectType.Overview)
        } else {
            this.setState({ ...this.state, isPopUp: true});
        }
    }

    render() {
        const accounts = this.getData();
        
        return (<>

        <div role="tabpanel" id="panel-6" tabIndex={0} aria-labelledby="tab-6">
            <div className="row narrow-gutter">
                <div className="col-12">
                    <h3>ESG Hub</h3>
                        
                    {accounts.length === 0 
                        ? <p>No account eligible for ESG analysis has been found.</p>
                        : (<div>
							<p>
								The ESG Hub provides information on your client’s portfolio for specific ESG themes.
								You can select from a number of themes and align these with your client’s ESG preferences.
								These can then be saved for analysis and populated in a report to share with your client.
								Your client’s preferences can be easily customised to allow you to tailor the information displayed to meet their needs.
							</p>
                            <a className="hyperlink-external"
                                role="link" 
                                onClick={() => this.onEsgLinkClick(accounts)}>
                                Launch ESG Hub
                            </a>
                        </div>)
                    }
                </div>
            </div>
            {this.renderAccountSelector()}
        </div>

        </>);
    }

    private addEvent = new AdviserSiteTagManager().addEvent;
}
